<template>
    <MasterTemplate 
        title="ข้อมูล รายการซ่อม" 
        :headers="headers" 
        :setData="setData"
        itemKey="serviceId"
        :getItemName="getItemName"
        :deleteData="deleteData"
        :insertData="insertData"
        :updateData="updateData"
        :listData="listData"
        >
        <template v-slot:formInput="{rules}">
            <v-row>
                <v-col cols="4" >
                    <v-text-field label="รหัสรายการซ่อม" autofocus maxlength="20" v-model="editedItem.serviceCode" :rules="[rules.required, chkCode]"></v-text-field>
                </v-col>
                <v-col cols="8" >
                    <v-text-field  label="ชื่อรายการซ่อม" maxlength="100" v-model="editedItem.serviceName" :rules="[rules.required]"></v-text-field>
                </v-col>
            </v-row>
        </template>
    </MasterTemplate>

</template>

<script>
    import MasterTemplate from '@/components/MasterTemplate'
    import {listService, insertService, updateService, deleteService, isExistServiceCode} from '@/api/master/service-api.js'
    export default {
        name: 'Service',
        components: {
            MasterTemplate
        },
        computed: {
            chkCode() {
                if (this.isDup == true) return 'รหัสงานซ่อมซ้ำ';
                return true;
            }
        },
         watch: {
            'editedItem.serviceCode': function(newVal) {
                if (!this.editedItem.serviceId) {
                    this.editedItem.serviceId = '-1';
                }
                if (newVal && this.editedItem.serviceId) {
                    isExistServiceCode(newVal, this.editedItem.serviceId).then(response => {
                        this.isDup = response;
                    }).catch(() => {
                        this.isDup = false;
                    });
                }
            }
        },
        data() {
            return {
                isDup: false,
                headers : [
                    {text: 'รหัสงานซ่อม', value: 'serviceCode'},
                    {text: 'ชื่องานซ่อม', value: 'serviceName'},
                    {text: 'Actions', value: 'action', sortable: false}
                ],
                editedItem: {
                    serviceId: '-1',
                    serviceCode: '',
                    serviceName: ''
                },
                desserts: [],
                search: '',
            }
        },
        methods: {
            listData() {
            return listService();
            },
            deleteData(item) {
                return deleteService(item.serviceId);
            },
            insertData() {
                return insertService(this.editedItem);
            },
            updateData() {
                return updateService(this.editedItem);
            },
            getItemName(item) {
                return item.serviceName;
            },
            setData(item) {
                this.editedItem = item;
            }
        }
    }
</script>